import { useEffect, useState } from "react";
import api from "@/lib/api";

// Mirrors the server's "classic" palette so charts render before the cosmetics state loads.
export const DEFAULT_PALETTE = {
  bg: "#0A0E16", text: "#94A3B8", text_muted: "#64748B", grid: "rgba(148,163,184,0.06)",
  border: "rgba(148,163,184,0.15)", up: "#10B981", down: "#EF4444", wick_up: "#34D399", wick_down: "#F87171",
  vol_up: "rgba(16,185,129,0.5)", vol_down: "rgba(239,68,68,0.5)", vwap: "#06B6D4", ema9: "#F59E0B",
  ema20: "#8B5CF6", ema50: "#38BDF8", ema200: "#F472B6", rsi: "#8B5CF6", entry: "#F8FAFC", stop: "#FB923C",
  target: "#A3E635", support: "#10B981", resistance: "#EF4444", level: "#06B6D4", answer: "#F8FAFC",
};

let current = null;
let owner = null;
let pending = null;
const subs = new Set();
const publish = (s) => { current = s; subs.forEach((f) => f(s)); };

export const loadCosmetics = (force = false) => {
  const token = localStorage.getItem("tc_token");
  if (!token) return Promise.resolve(null);
  if (token !== owner) { owner = token; current = null; pending = null; force = true; }
  if (!force && (current || pending)) return pending || Promise.resolve(current);
  pending = api.get("/cosmetics").then((r) => { publish(r.data); return r.data; })
    .catch(() => null).finally(() => { pending = null; });
  return pending;
};
export const setCosmetics = publish;

export const useCosmetics = () => {
  const [s, setS] = useState(current);
  useEffect(() => { subs.add(setS); loadCosmetics(); return () => subs.delete(setS); }, []);
  return s;
};

export const useChartPalette = () => {
  const s = useCosmetics();
  const t = s?.themes?.find((x) => x.key === s.chart_theme);
  return t?.palette || DEFAULT_PALETTE;
};
